import React, { useEffect, useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Row } from "reactstrap";
import BlogNav from "../Blog/BlogNav";
import { faqItems } from "../Data/Otherpage/otherpagedata";
import AnimationCommon from "../common/AnimationCommon";
import CustomBreadcrumb from "../common/Breadcrumb";
import Footer from "../components/footer";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };
  useEffect(() => {
    document.body.classList.remove("landing-page");
    document.body.classList.add("inner-page");
  }, []);
  return (
    <div>
      <BlogNav />
      <div className='page-margin'>
        <CustomBreadcrumb title={"FAQ"} items={"FAQ"} />
        <section className='faq blog-page'>
          <Container>
            <Row>
              <Col md='12'>
                <div className='accordion'>
                  {faqItems.map((item, index) => (
                    <Card key={item.id} className='mb-3'>
                      <CardHeader id={`heading${item.id}`}>
                        <h5 className='mb-0'>
                          <Button className={`${activeIndex === index ? "active-faq" : ""}`} color='' onClick={() => toggle(index)}>
                            {item.title}
                            {activeIndex === index ? <FaAngleUp className='updown' /> : <FaAngleDown className='updown' />}
                          </Button>
                        </h5>
                      </CardHeader>
                      <Collapse isOpen={activeIndex === index} id={`collapse${item.id}`}>
                        <CardBody>{item.body}</CardBody>
                      </Collapse>
                    </Card>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
          <AnimationCommon />
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default Faq;
